module.exports = __webpack_public_path__ + "img/sort-amount-up-alt.7f5574cc.svg";